import { Component, OnDestroy, OnInit } from '@angular/core';
import { LoadingController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { debounce, interval, Subscription } from 'rxjs';
import { LoadingIndicatorState } from './services';

@Component({
	selector: 'app-loading-indicator',
	template: ''
})
export class LoadingIndicatorComponent implements OnInit, OnDestroy {
	private loadingIndicator: HTMLIonLoadingElement | undefined;
	private loadingSubscription: Subscription;

	public constructor(
		private loadingController: LoadingController,
		private loadingIndicatorState: LoadingIndicatorState,
		private translate: TranslateService
	) {}

	public async ngOnInit(): Promise<void> {
		this.loadingSubscription = this.loadingIndicatorState.isLoading$
			/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
			.pipe(debounce((_) => interval(1000)))
			.subscribe(async ({ isLoading, message }) => {
				if (isLoading) {
					await this.presentLoading(message);
				} else {
					if (this.loadingIndicator) {
						await this.loadingIndicator.dismiss();
					}
				}
			});
	}

	public ngOnDestroy(): void {
		this.loadingSubscription.unsubscribe();
	}

	private async presentLoading(customMessage: undefined | string): Promise<void> {
		const cssClass = ['loading-indicator'];
		let message = this.translate.instant('loadingIndicator.message');

		if (customMessage) {
			message = `${message} <span>${customMessage}</span>`;
			cssClass.push('loading-extra-message');
		}

		this.loadingIndicator = await this.loadingController.create({
			cssClass,
			message
		});
		await this.loadingIndicator.present();
	}
}
